import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppSettings, defaults } from '../app.config';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  get notify(): Observable<Record<string, any>> {
    return this.notify$.asObservable();
  }

  private notify$ = new BehaviorSubject<Record<string, any>>({});
 
  ///Metodo que se encarga de obtener las configuraciones que se hicieron previamente
  getOptions() {
    return this.options;
  }
  ///Metodo que se encarga de configurar las opciones de configuración
  setOptions(options: AppSettings) {
    this.options = Object.assign(defaults, options);
    this.notify$.next(this.options);
  }

  private options = defaults;
  ///Metodo que se encarga de obtener el lenguaje que se configuro previamente
  getLanguage() {
    return this.options.language;
  }
  ///Metodo que se encarga de actualizar la configuracion del idioma
  setLanguage(lang: string) {
    this.options.language = lang;
    this.notify$.next({ lang });
  }
}
